import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import classNames from "classnames"
import ReactHeight from "react-height"

import Tag from "@irati/ui/src/Tag"

import "./styles/Categories.css"

class Categories extends Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    isShowingMore: PropTypes.bool.isRequired,
    handleCategoryClick: PropTypes.func.isRequired,
    displayShowMoreText: PropTypes.bool.isRequired,
    shouldDisplayShowMoreText: PropTypes.func.isRequired,
    selected: PropTypes.object
  }

  static defaultProps = {
    selected: null
  }

  onHeightReady = (height) => {
    if (!this.props.displayShowMoreText && height > 60) {
      this.props.shouldDisplayShowMoreText()
    }
  }

  render() {
    const {data, isShowingMore, handleCategoryClick, displayShowMoreText, selected} = this.props

    const className = classNames({
      categoryTagsCategories_showMoreSelected: displayShowMoreText && isShowingMore,
      categoryTagsCategories_showMoreUnSelected: displayShowMoreText && !isShowingMore
    })

    return (
      <ReactHeight onHeightReady={this.onHeightReady}>
        <div className={className}>
          {data.map((category) => {
            return (
              <Tag
                name={category.name}
                count={category.dealCount}
                selected={selected === category}
                uppercase={!category.titleNotUppercase}
                onClick={() => handleCategoryClick(category)}
                key={category.name} />
            )
          })}
        </div>
      </ReactHeight>
    )
  }
}

const mapStateToProps = ({mq}) => ({mq})

export default connect(mapStateToProps)(Categories)
